export default {
  name: 'TitleNavBar',
  props: {
    title: { type: String, required: true },
    desc: { type: String, required: true },
    prev: { type: String },
  },
  data: () => ({ }),

  mounted() {},
  methods: {},
};



// WEBPACK FOOTER //
// ./src/components/layout/js/TitleNavBar.js